

const landingNavbarData = [
 {
  id: 0,
  name: 'Home',
  link: "/home"
 },
 {
  id: 1,
  name: 'About',
  link: "/about"
 },
 {
  id: 3,
  name: 'Learnings',
  link: "/learnings"
 },
 {
  id: 4,
  name: 'Contact',
  link: "/contact"
 }
]

export default landingNavbarData;